// Display the available passport records and assignment events without guessing missing dates.
export function passportHistoryRows(passports, logs) {
  const byId = new Map(passports.filter(p => p?.passport_id).map(p => [p.passport_id, p]));
  const rows = [...byId.values()].map(p => ({
    key: 'passport-' + p.passport_id,
    kind: p.status === 'CANCELLED' ? 'cancel' : 'new',
    label: p.status === 'CANCELLED' ? '취소' : '신규',
    target: p.owner_name || '대상자 미확인',
    store: p.store_name || (p.store_id != null ? '지점 ' + p.store_id : '지점 미확인'),
    occurredAt: p.status === 'CANCELLED' ? (p.cancelled_at || null) : (p.issue_date || p.issued_at || p.created_at || null),
  }));
  const seen = new Set();
  logs.forEach((log, index) => {
    const key = log.id ?? 'row-' + index;
    if (seen.has(key)) return;
    seen.add(key);
    const passport = byId.get(log.passport_id);
    rows.push({
      key: 'assignment-' + key, kind: 'assign', label: '할당',
      target: (log.from_name || log.from_member_name || '미할당') + ' → ' + (log.to_name || log.to_member_name || '대상자 미확인'),
      store: log.store_name || passport?.store_name || (passport?.store_id != null ? '지점 ' + passport.store_id : '지점 미확인'),
      occurredAt: log.assigned_at || null,
    });
  });
  const time = value => { const date = value ? new Date(value).getTime() : NaN; return Number.isFinite(date) ? date : -Infinity; };
  return rows.sort((a,b) => time(b.occurredAt) - time(a.occurredAt));
}
